module.exports = __webpack_public_path__ + "static/media/Messages.eeddf433.svg";